import apiUrl from '../../../constants'
import axios from 'axios'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import CryptoJS from 'crypto-js'
import vSelect from 'vue-select'

//import vueSpinner from 'vue-spinner'
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
// import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import {
  Validator
} from 'vee-validate'
import Loader from './../shared/loader'

export default {
  name: 'grc',
  components: {
    Multiselect,
    Loader,
    // PulseLoader,
    // ClipLoader,
    vSelect
  },
  props: [],
  data() {
    return {
      rejectOptions: [],
      holdOptions: [],
      // 	{	library: 'Vue.js' },
      //   { library: 'Vue-Multiselect' },
      //   { library: 'Vuelidate' }
      // ],
      todayDate: '',
      size: '30px',
      isFoundTotalCheckqty: false,
      rejectedReasonList: [],
      holdReasonList: [],
      selected: '',
      DRerrors: '',
      IDerrors: '',
      MRPerrors: '',
      MRPsuccess: '',
      isError: '',
      checked: false,
      selected: '',
      searchProductFlt: '',
      productSearchModal: false,
      expiryDetailsModal: false,
      invoicePQuantity: 0,
      checkQtyerrors: '',
      acceptQtyerrors: '',
      rejectQtyerrors: '',
      holdQtyerrors: '',
      rejectReasonErrors: '',
      holdReasonErrors: '',
      searchProductFltError: '',
      expiryDtlErrors: '',
      rejectReason: [],
      holdReason: [],
      productDescription: '',
      selectPoNoList: [],
      checkProductMrp: 0,
      isfound: false,
      isnotfound: false,
      isfoundID: false,
      isnotfoundID: false,
      isfoundMRP: false,
      isnotfoundMRP: false,
      isfoundReject: false,
      shelfLifeCheck: false,
      isExpiry: true,
      lotControlCheck: false,
      isExpiryCol: false,
      totalRemainForThis: 0,
      totalCheckedQty: 0,
      loginUserEmail: '',
      addGRC: {
        DRNo: '',
        productid: '',
        productdesc: '',
        MRP: '',
        productqty: 0,
        checkedqty: 0,
        acceptedqty: 0,
        mfgdate: '',
        shelfLife: '',
        expdate: '',
        rejectedqty: 0,
        holdqty: 0,
        productImage: '',
        ifHold: '',
        pono: '',
        inwardid: '',
        invoiceno: '',
        pickPoNo: '',
        warehouseid: 0,
        lotControl: ''
      },
      loading: false,
      loadingText: '<i class="fa fa-spinner fa-spin fa-2x" style="color:#1985ac"></i>',
      rightIcon: '<i class="fa fa-check" style="font-size:25px;color:green" v-if="isfoundID"></i>',
      wrongIcon: '<i class="fa fa-close" style="font-size:25px;color:red" v-if="isnotfoundID"></i>',
      productCheckIcon: '',
      isLoading: false
    }
  },
  computed: {
    isComplete() {
      var isComplete = this.addGRC.DRNo && this.addGRC.productid && this.addGRC.MRP && this.addGRC.checkedqty && this.addGRC.acceptedqty;
      if (parseFloat(this.addGRC.checkedqty) != parseFloat(this.addGRC.acceptedqty) && parseFloat(this.addGRC.checkedqty) != '' && parseFloat(this.addGRC.acceptedqty) != '') {
        isComplete = this.checkRejectHoldQty();
      }
      return isComplete;
    },
    isEnblRejectReason() {
      if (this.addGRC.rejectedqty > 0) {
        return true;
      } else {
        return false;
      }
    },
    isEnblHoldReason() {
      if (this.addGRC.holdqty > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    this.todayDate = moment().format('DD/MM/YYYY');
    this.loadRejectReason();
    this.showSearchDR('');
  },
  created() {
    this.$validator.extend('currentCheckQty', {
      getMessage: field => `Total checked qty cannot be greater than total invoice product qty. Please enter a qty less than or equal to total invoice product qty.`,
      validate: value => {
        if (value) {
          if (parseFloat(value) > parseFloat(this.addGRC.productqty)) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
    });
    this.$validator.extend('totalAcceptQty', {
      getMessage: field => `Total accepted qty cannot be greater than total checked qty. Please enter a qty less than or equal to total checked qty.`,
      validate: value => {
        if (value) {
          if (parseFloat(value) > parseFloat(this.addGRC.checkedqty)) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
    });
  },
  methods: {

    customLabel(option) {
      return `${option.reasonname}`
    },
    getLocalUserData() {
      var userdetailEncrypt = window.localStorage.getItem('userdetail')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      return userdetail;
    },

    isNumeric: function(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },

    loadRejectReason() {

      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.input = ({
        reasonType: 'reject'
      });
      this.isLoading = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'rejectReasonList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.status) {
            for (var i = 0; i < result.data.result.length; i++) {
              this.rejectOptions.push(result.data.result[i].reasonname);
            }
            this.rejectedReasonList = result.data;
          }
        }, error => {
          this.isLoading = false;
          //console.error(error)
        });

      this.input = ({
        reasonType: 'hold'
      });
      this.isLoading = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'rejectReasonList',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.status) {
            for (var i = 0; i < result.data.result.length; i++) {
              this.holdOptions.push(result.data.result[i].reasonname);
            }
            this.holdReasonList = result.data;
          }
        }, error => {
          this.isLoading = false;
          //console.error(error)
        });
    },

    showSearchDR(e) {

      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');


      var code = (e.keyCode || e.which);
      // do nothing if it's an arrow key
      if (code == 37 || code == 38 || code == 39 || code == 40) {
        return;
      }

      this.DRerrors = '';
      this.isfound = false;
      this.isnotfound = true;

      this.addGRC.productid = '';
      this.isfoundID = false;

      if (this.$route.params.drno && this.$route.params.drno != '') {
        var drNo = this.$route.params.drno.trim();
      }

      if (this.addGRC.DRNo.trim() != '') {
        var drNo = this.addGRC.DRNo.trim();
      }
      if (drNo != '' && drNo.length > 4) {
        this.addGRC.DRNo = drNo;
        this.isLoading = true;
        axios.post(apiUrl.api_url + 'validateDR', {
            'invreferenceid': drNo,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }
          })
          .then((response) => {
            this.isLoading = false;
            if (response.data.errorCode == 0) {
              this.isfound = true;
              this.isnotfound = false;
              this.DRerrors = '';
            } else {
              this.DRerrors = 'Please insert valid DR number';
              this.isfound = false;
              this.isnotfound = true;
            }
          })
        this.isLoading = false;
      }
    },

    searchProduct(scope) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');


      this.searchProductFltError = "";
      this.addGRC.productid = '';

      this.isfoundID = false;
      this.isnotfoundID = true;

      this.isfoundMRP = false;
      this.addGRC.MRP = 0;

      this.MRPerrors = "";
      this.MRPsuccess = "";
      if (this.searchProductFlt != '') {
        if (this.isNumeric(this.searchProductFlt)) {
          this.input = ({
            searchKey: this.searchProductFlt.trim()
          });
          this.isLoading = true;
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'productSearch',
              'data': this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then(result => {
              this.isLoading = false;
              if (result.data.status) {
                this.addGRC.productid = result.data.result[0].productid;
                this.showSearchProduct('');
                this.productSearchModal = false;
                this.getElementByIdFn("productid", result.data.result[0].productid);
              } else {
                this.searchProductFltError = result.data.message;
              }
            }, error => {
              this.isLoading = false;
              console.error(error)
            });
        } else {
          this.searchProductFltError = "The Product id OR EAN code should be number";
        }
      } else {
        this.searchProductFltError = "The Product id OR EAN code is required";
      }
    },

    showSearchProduct(e) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      var code = (e.keyCode || e.which);
      // do nothing if it's an arrow key
      if (code == 37 || code == 38 || code == 39 || code == 40) {
        return;
      }
      this.IDerrors = '';
      this.isfoundID = false;
      this.isnotfoundID = true;

      this.isfoundMRP = false;
      this.addGRC.MRP = 0;

      /* For Expiry*/
      this.shelfLifeCheck = false;
      this.lotControlCheck = false;
      this.isExpiry = true;
      this.isExpiryCol = false;
      this.addGRC.shelfLife = '';
      this.addGRC.mfgdate = '';
      this.addGRC.expdate = '';
      this.addGRC.lotControl = '';
      if (this.addGRC.productid != '') {
        if (this.isNumeric(this.addGRC.productid)) {
          this.productCheckIcon = this.loadingText;
          this.isLoading = true;
          this.input = ({
            'productid': this.addGRC.productid.trim(),
            'invreferenceid': this.addGRC.DRNo.trim(),
            'actionType': 'productID'
          });

          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'ProductList',
              'data': this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })
            .then((response) => {
                this.isLoading = false;
                if (response.data.status) {
                  this.IDerrors = '';
                  this.isnotfoundID = false;
                  this.isfoundID = true;
                  this.productCheckIcon = this.rightIcon;

                  this.addGRC.pono = response.data.result[0].pono;
                  this.addGRC.inwardid = response.data.result[0].inwardid;
                  this.addGRC.invoiceno = response.data.result[0].invoiceno;
                  this.addGRC.productdesc = response.data.result[0].productdescription;
                  this.productDescription = response.data.result[0].productdescription;
                  this.addGRC.productImage = response.data.result[0].productimage;
                  this.addGRC.pickPoNo = response.data.result[0].pono;
                  this.checkProductMrp = response.data.result[0].mrp;

                  if (response.data.result[0].nocontrol == 0) {
                    if (response.data.result[0].shelflifeduration != 0) {
                      this.addGRC.shelfLife = response.data.result[0].shelflifeduration + " " + response.data.result[0].shelflifeuom;
                      this.shelfLifeCheck = true;
                    }
                    if (response.data.result[0].lotcontrol > 0) {
                      this.lotControlCheck = true;
                      this.addGRC.lotControl = '';
                    }
                  } else {
                    this.isExpiry = false;
                  }
                  if (response.data.result[0].warehouseid) {
                    this.addGRC.warehouseid = response.data.result[0].warehouseid;
                  }
                  this.selectPoNoList = response.data;
                } else {
                  this.productCheckIcon = this.wrongIcon;
                  this.IDerrors = response.data.message;
                  return false;
                }
              },
              error => {
                this.isLoading = false;
                this.productCheckIcon = this.wrongIcon;
                this.IDerrors = "Enter wrong product ID, Please enter valid product ID";
                return false;
              });
        } else {
          this.IDerrors = 'The Product ID field should be number only';
          return false;
        }
      } else {
        this.IDerrors = 'The Product ID field is required';
        return false;
      }
      this.getElementByIdFn("MRP", 0);
    },

    searchProductMRP() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.MRPerrors = "";
      this.MRPsuccess = "";
      this.isError = true;
      this.isfoundMRP = '';
      this.isnotfoundMRP = true;
      if (this.isNumeric(this.addGRC.MRP)) {
        if (this.addGRC.MRP > 0) {
          this.input = ({
            'productid': this.addGRC.productid.trim(),
            'invreferenceid': this.addGRC.DRNo.trim(),
            'mrp': this.addGRC.MRP.trim(),
            'pono': this.addGRC.pickPoNo.trim(),
            'actionType': 'MRP'
          });

          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
              'data': this.input,
              headers: {
                'Authorization': 'Bearer ' + myStr
              }
            })

            .then((response) => {
                if (response.data.status) {
                  this.isError = '';
                  this.isnotfoundMRP = '';
                  this.MRPerrors = '';
                  //this.MRPsuccess = "MRP entered successfully";
                  this.isfoundMRP = true;
                  this.addGRC.productqty = response.data.result[0].quantity;
                  this.invoicePQuantity = response.data.result[0].quantity + " Ea.";
                  this.existsProductGrcCheck();
                } else {
                  this.MRPerrors = response.data.message;
                  return false;
                }
              },
              error => {
                this.MRPerrors = "MRP entered does not match with PO. Please enter correct MRP";
                return false;
              })
        } else {
          this.MRPerrors = "MRP field is required";
          return false;
        }
      } else {
        //this.MRPerrors = 'MRP should be decimal.  Enter a correct MRP';
      }
    },

    existsProductGrcCheck() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.isFoundTotalCheckqty = false;
      this.isLoading = true;
      this.input = ({
        'productid': this.addGRC.productid.trim(),
        'invreferenceid': this.addGRC.DRNo.trim(),
        'mrp': this.addGRC.MRP.trim(),
        'pono': this.addGRC.pickPoNo.trim()
      });

      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'existsProductGrcCheck',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
            this.isLoading = false;
            if (response.data.status) {
              if (response.data.result[0].remainqty > 0) {
                this.isFoundTotalCheckqty = true;
                this.totalCheckedQty = response.data.result[0].checkedquantity;
                this.totalRemainForThis = response.data.result[0].remainqty;
                this.addGRC.productqty = response.data.result[0].remainqty;
                return true;
              }
            } else {
              return false;
            }
          },
          error => {
            this.isLoading = false;
            return false;
          });
    },

    resetMrp() {
      this.$validator.reset();
      this.errors.clear();
      this.isfoundMRP = '';
      this.getElementByIdFn("MRP", 0);
    },

    openSearchProductModal(event) {
      this.productSearchModal = true;
      this.getElementByIdFn("searchProductFlt", "");
      this.searchProductFlt = '';
    },

    validateQty(check) {
      this.rejectQtyerrors = '';
      this.holdQtyerrors = '';
      if (check == "currentCheckQty") {
        this.showRejectedQuantity(false);
        this.addGRC.acceptedqty = 0;
        this.getElementByIdFn("acceptedqty", 0);
      } else if (check == "acceptqty") {
        this.showRejectedQuantity(false);
        this.addGRC.rejectedqty = 0;
        this.addGRC.holdqty = 0;
        if (parseFloat(this.addGRC.checkedqty) != parseFloat(this.addGRC.acceptedqty) && this.addGRC.checkedqty != '' && this.addGRC.acceptedqty != '') {
          this.showRejectedQuantity(true);
        }
      } else if (check == "rejectqty") {
        if (parseFloat(this.addGRC.rejectedqty) > (parseFloat(this.addGRC.checkedqty) - parseFloat(this.addGRC.acceptedqty)) && this.addGRC.rejectedqty > 0) {
          this.rejectQtyerrors = "Total rejected qty cannot be greater than total checked qty minus total accepted qty. Please enter a correct value.";
          //this.addGRC.holdqty = 0;
        }
      } else if (check == "holdqty") {
        if (parseFloat(this.addGRC.holdqty) != (parseFloat(this.addGRC.checkedqty) - (parseFloat(this.addGRC.acceptedqty) + parseFloat(this.addGRC.rejectedqty))) && this.addGRC.holdqty > 0) {
          this.holdQtyerrors = "Invalid hold qty, Please enter a correct value.";
        }
      }
    },

    showRejectedQuantity(res) {
      this.getElementByIdFn("rejectedqty", 0);
      this.getElementByIdFn("holdqty", 0);
      if (res) {
        this.isfoundReject = true;
      } else {
        this.isfoundReject = false;
      }
    },

    openExpiryModal(event) {
      this.expiryDetailsModal = true;
    },

    expiryDetailsForm(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          //console.log("valid");
          this.expiryDetailsModal = false;
          this.isExpiryCol = true;
          this.expiryDtlErrors = "";
        } else {
          //console.log("invalid");
          this.isExpiryCol = false;
        }
      });
    },

    saveGRC(scope) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');


      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.rejectReasonErrors = this.holdReasonErrors = this.expiryDtlErrors = '';
          this.$validator.validateAll('expiryForm').then((result) => {
            if (result) {
              //this.checkRejectHoldQty();
              if ((this.addGRC.rejectedqty != '' && this.addGRC.rejectedqty != 0) && this.rejectReason.length == 0) {
                this.rejectReasonErrors = "Please select valid reason for rejection";
                return false;
              }
              if ((this.addGRC.holdqty != '' && this.addGRC.holdqty != 0) && this.holdReason.length == 0) {
                this.holdReasonErrors = "Please select valid reason for holding";
                return false;
              }
              if (this.addGRC.rejectedqty == '') {
                this.addGRC.rejectedqty = 0;
              }
              if (this.addGRC.holdqty == '') {
                this.addGRC.holdqty = 0;
              }
              if (this.addGRC.lotControl == '') {
                this.addGRC.lotControl = 0;
              }
              var grcStatus = "done";
              if (this.addGRC.checkedqty < this.addGRC.productqty) {
                var grcStatus = "not done";
              }

              var userdetail = this.getLocalUserData();
              if (userdetail) {
                this.loginUserEmail = userdetail.email;
                this.addGRC.warehouseid = userdetail.warehouseid;
              }

              this.input = ({
                pono: this.addGRC.pickPoNo,
                //poitemid: this.addGRC.pono,
                invreferenceid: this.addGRC.DRNo,
                inwardid: this.addGRC.inwardid,
                invoiceno: this.addGRC.invoiceno,
                productid: this.addGRC.productid,
                orderedquantity: this.addGRC.productqty,
                invoicequantity: this.addGRC.productqty,
                checkedquantity: this.addGRC.checkedqty,
                totalreceivequantity: this.addGRC.acceptedqty, // recive quantity
                rejectedquantity: this.addGRC.rejectedqty,
                onholdquantity: this.addGRC.holdqty,
                mrp: this.addGRC.MRP,
                createdby: this.loginUserEmail,
                lastmodifiedby: this.loginUserEmail,
                grnstatus: grcStatus,
                grcstatus: grcStatus,
                warehouseid: this.addGRC.warehouseid,
                rejectReason: this.rejectReason,
                holdReason: this.holdReason,
                manufacturingdate: this.addGRC.mfgdate,
                expirydate: this.addGRC.expdate,
                lotControl: this.addGRC.lotControl,
                shelfLife: this.addGRC.shelfLife
              });
              this.isLoading = true;
              console.log(this.input);
              return false;
              axios({
                  method: 'POST',
                  'url': apiUrl.api_url + 'CreateGRC',
                  'data': this.input,
                  headers: {
                    'Authorization': 'Bearer ' + myStr
                  }
                })
                .then((response) => {
                  this.isLoading = false;
                  if (response.data.errorCode == 0) {
                    this.$alertify.success(response.data.msg);
                  } else {
                    this.$alertify.error(response.data.msg);
                  }
                  this.$validator.reset(scope);
                  this.resetScope();
                })
                .catch((httpException) => {
                  this.isLoading = false;
                  this.$alertify.error("Exception error try again");
                });
            } else {
              this.ExpiryDateFlag = false;
              this.expiryDtlErrors = "Expiry details is required, Enter correct details";
              return false;
            }
          });
        } else {
          return false;
        }
      });
    },

    checkRejectHoldQty() {
      if ((parseFloat(this.addGRC.checkedqty) != parseFloat(this.addGRC.acceptedqty)) && (parseFloat(this.addGRC.rejectedqty) + parseFloat(this.addGRC.holdqty) != parseFloat(this.addGRC.checkedqty) - parseFloat(this.addGRC.acceptedqty))) {
        //console.log("invalid");
        return false;
      } else {
        return true;
      }
    },

    resetScope() {
      var self = this;
      self.isfound = false;
      self.isnotfound = false;
      self.isfoundID = false;
      self.isnotfoundID = false;
      self.isfoundMRP = false;
      self.isnotfoundMRP = false;
      self.isfoundReject = false;
      self.shelfLifeCheck = false;
      self.isExpiry = true;
      self.lotControlCheck = false;
      self.isExpiryCol = false;
      Object.keys(this.addGRC).forEach(function(key, index) {
        if (key == "productqty" || key == "checkedqty" || key == "acceptedqty" || key == "rejectedqty" || key == "holdqty" || key == "warehouseid") {
          self.addGRC[key] = 0;
        } else {
          if (self.addGRC[key] != "DRNo") {
            self.addGRC[key] = '';
          }
        }
      });
      this.showSearchDR('');
    },

    getElementByIdFn(elmId, val) {
      document.getElementById(elmId).value = val;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/GRC/grc.component.js